export default __webpack_public_path__ + "static/media/icon_acc_video.8cb48cbf.svg";